import React from 'react';
import FetchDataWrapper from '../../../../../../components/FetchDataWrapper';
import {
  registrationStateTypes,
  useRegistrationSubscribe,
} from '../../../../services/acceptanceRegistration';

const FetchCurrentIntervalData = ({
  children,
  addressStatus,
  selectedOwnerStatus,
}) => {
  const addressesAndClientState = useRegistrationSubscribe({
    type: registrationStateTypes.addressesAndClient,
  });

  if (addressStatus === 'success' && selectedOwnerStatus === 'success') {
    return <>{children}</>;
  }

  return (
    <FetchDataWrapper
      data={addressesAndClientState.value ?? {}}
      isFetching={addressesAndClientState.status === 'loading'}
      refetch={addressesAndClientState.refetch}
      errMsg={addressesAndClientState.message}
      ignoreEmpty
    >
      {children}
    </FetchDataWrapper>
  );
};

export default FetchCurrentIntervalData;
